var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cemetery-administration" },
    [
      _c("CemeterySectorsStatistic", {
        attrs: {
          cemeteryCode: _vm.code,
          panelCfg: _vm.panelCfg,
          parentId: _vm.parentId,
          moduleCode: _vm.moduleCode,
          additional: _vm.additional,
          baseTranslateID: _vm.baseTranslateID,
        },
        model: {
          value: _vm.administration,
          callback: function ($$v) {
            _vm.administration = $$v
          },
          expression: "administration",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }